import * as React from "react";
import { useTranslation } from "react-i18next";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

export interface AdminTopbarProps {
  breadcrumb?: React.ReactNode;
  user: { firstName: string; lastName: string };
  onAvatarClick?: () => void;
  action?: React.ReactNode;
}

export function AdminTopbar({ breadcrumb, user, onAvatarClick, action }: AdminTopbarProps) {
  const { t } = useTranslation();
  return (
    <header
      style={{ viewTransitionName: "vroom-topbar" }}
      className="flex h-12 items-center justify-between gap-4 border-b border-line bg-surface px-4"
    >
      <div className="text-[12.5px] text-ink-700">{breadcrumb}</div>
      <div className="flex items-center gap-3">
        {action}
        <button
          type="button"
          onClick={onAvatarClick}
          aria-label={t("common.nav.profile.label")}
          className="rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-p-600 focus-visible:ring-offset-2"
        >
          <Avatar>
            <AvatarFallback initials={`${user.firstName.charAt(0)}${user.lastName.charAt(0)}`} />
          </Avatar>
        </button>
      </div>
    </header>
  );
}
